(function () {
  const updateNavigationVisibility = (swiper, section) => {
    const navEl = section.querySelector(".testimonials__nav");
    const slider = section.querySelector(".testimonials__slider");
    if (!navEl || !slider) return;

    if (swiper.isLocked) {
      navEl.style.display = "none";
      slider.classList.add("testimonials__slider--static");
    } else {
      navEl.style.display = "";
      slider.classList.remove("testimonials__slider--static");
    }
  };

  const initSlider = (section) => {
    const slider = section.querySelector(".testimonials__slider");
    if (!slider || slider.swiper) return;

    const prevBtn = section.querySelector(".testimonials__button--prev");
    const nextBtn = section.querySelector(".testimonials__button--next");
    const paginationEl = section.querySelector(".testimonials__pagination");
    const navEl = section.querySelector(".testimonials__nav");

    const slides = slider.querySelectorAll(".testimonials__slide");
    if (slides.length <= 1) {
      slider.classList.add("testimonials__slider--static");
      if (navEl) navEl.style.display = "none";
      if (paginationEl) paginationEl.style.display = "none";
      if (prevBtn) prevBtn.style.display = "none";
      if (nextBtn) nextBtn.style.display = "none";
      return;
    }

    if (navEl) navEl.style.display = "";

    new Swiper(slider, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      allowTouchMove: true,
      mousewheel: { forceToAxis: true },
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: "auto",
        },
        1200: {
          slidesPerView: "auto",
        },
      },
      on: {
        init: function () {
          updateNavigationVisibility(this, section);
        },
        resize: function () {
          updateNavigationVisibility(this, section);
        },
        breakpoint: function () {
          updateNavigationVisibility(this, section);
        },
        lock: function () {
          updateNavigationVisibility(this, section);
        },
        unlock: function () {
          updateNavigationVisibility(this, section);
        },
        update: function () {
          updateNavigationVisibility(this, section);
        },
      },
    });
  };

  const initTestimonials = (section) => {
    if (!section?.classList.contains("testimonials-section")) return;
    if (!section.querySelector(".testimonials__slider")) return;
    initSlider(section);
  };

  const section = document.currentScript?.closest(".testimonials-section");
  if (section) initTestimonials(section);

  document.addEventListener("shopify:section:load", (event) => {
    initTestimonials(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const slider = event.target?.querySelector(".testimonials__slider");
    if (slider?.swiper) {
      slider.swiper.destroy(true, true);
    }
  });
})();
